import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import b from 'b_';
import cn from 'classnames';
import { Key } from '../../mirror/userInput';
import InputStore from '../../stores/InputStore';
import Button from '../Button';
import Icon from '../Icon/Icon';
import './SearchField.css';

const block = b.lock('SearchField');

class SearchField extends Component {
    static propTypes = {
        inputStore: InputStore.PropType.isRequired,
        className: PropTypes.string,
        inputClassName: PropTypes.string,
        placeholder: PropTypes.string,
    };

    onClear = () => {
        this.props.inputStore.setValue('');
    };

    onKeyDown = (event) => {
        if (event.keyCode === Key.ESC) {
            this.onClear();
            event.stopPropagation();
        }
    };

    render() {
        const { inputStore, className, inputClassName, placeholder } = this.props;
        return <label className={cn(block({ notEmpty: !inputStore.isEmpty }), className)}>
            <input
                className={cn(block('Input'), inputClassName)}
                value={inputStore.value}
                onChange={inputStore.onChangeHandler}
                onKeyDown={this.onKeyDown}
                ref={inputStore.setRef}
            />
            <div className={block('Placeholder')}>
                <Icon
                    className={block('PlaceholderIcon')}
                    type="search"
                />
                <span>{placeholder}</span>
            </div>
            <Button
                className={block('Clear')}
                icon="cancel"
                onClick={this.onClear}
            />
        </label>;
    }
}

export default observer(SearchField);

